// extracted by mini-css-extract-plugin
export default {"kion-button":"styles_kion-button__lvxq-","negative":"styles_negative__fi85C","disabled":"styles_disabled__Vz9H9"};